import { memo, ReactNode } from "react";
import classNames from "classnames";
import { Link } from "react-router";
import { Button } from "../Button";

import styles from "./styles.module.scss";

export type SystemBannerProps = {
  title?: string
  subTitle?: string
  text?: string
  image?: ReactNode
  imageBlockClassName?: string
  className?: string
  homePageUrl?: string
}

export const SystemBanner = memo<SystemBannerProps>((
  {
    title,
    subTitle,
    text,
    image,
    imageBlockClassName,
    className,
    homePageUrl = "/",
  }) => {
  return (
    <div className={classNames(styles.root, className)}>
      <div className={classNames(styles.imageBlock, imageBlockClassName)}>
        {image}
      </div>
      <div className={styles.info}>
        <h1>{title}</h1>
        <h2>{subTitle}</h2>
        <p>{text}</p>
        <Button
          component={Link}
          to={homePageUrl}
          buttonType={"secondary"}
          className={styles.button}
        >
          Go to homepage
        </Button>
      </div>
    </div>
  );
});

export default SystemBanner;